export default theme => ({
    root: {
        flexShrink: 0,
        paddingBottom: theme.spacing(1),
    },
    divider: {
        margin: theme.spacing(1, 2),
        borderColor: 'rgba(255, 255, 255, 0.12)',
    },
    // Collapsed rail: stacked icon rows that mirror the nav card geometry, so the
    // icons land on the same centerline.
    listItem: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        width: 'auto',
        height: 40,
        margin: theme.spacing(0.25, 1),
        paddingLeft: theme.spacing(1.75),
        paddingRight: theme.spacing(1.5),
        borderRadius: theme.spacing(1),
        color: theme.palette.common.white,
        transition: theme.transitions.create('background-color'),
        '&:hover': {
            backgroundColor: theme.palette.secondary.hover,
        },
    },
    listItemIcon: {
        minWidth: 'auto',
        marginRight: theme.spacing(1.5),
        color: theme.palette.common.white,
    },
    listItemText: {
        fontWeight: 500,
        color: theme.palette.common.white,
    },
    notificationBadge: {
        backgroundColor: theme.palette.error.dark,
    },
    avatar: {
        width: 28,
        height: 28,
        fontSize: '0.75rem',
        backgroundColor: theme.palette.secondary.main,
    },
    // Expanded: the account on the left, notification + help actions on the right.
    accountRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        padding: theme.spacing(0, 0.5),
    },
    accountButton: {
        flex: '1 1 auto',
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: theme.spacing(1.5),
        margin: theme.spacing(0.25, 0.5),
        padding: theme.spacing(0.75, 1.5),
        borderRadius: theme.spacing(1),
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.secondary.hover,
        },
    },
    accountName: {
        fontWeight: 500,
        fontSize: '0.875rem',
        lineHeight: 1.4,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    iconAction: {
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40,
        borderRadius: theme.spacing(1),
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.secondary.hover,
        },
    },
    minified: {
        '& .MuiListItemText-root': {
            display: 'none',
        },
        '& $avatar': {
            width: 22,
            height: 22,
            fontSize: '0.625rem',
        },
    },
});
